import React, { useState } from "react";

import { Col, Container, Row } from "react-bootstrap";

import studentBoyImgSrc from "../../../../image/home/student-boy.png";
import ModalComponent from "../../modal";
import VideoPlayerComponent from "../../videoPlayer";

import {
  StyledSection,
  HeroContentWrapper,
  HeroButtonsWrapper,
  StyledHeroButton,
  StyledVideoCircle,
  PlayIcon,
  HeroBoyWrapper,
} from "./styledHeroSection";

const HeroSectionComponent = () => {
  const [isVideoModal, setIsVideoModal] = useState(false);
  const [modalVideoSrc, setModalVideoSrc] = useState("");
  const handleShowVideoModal = (videoAddress) => {
    setIsVideoModal(!isVideoModal);
    setModalVideoSrc(videoAddress);
  };

  return (
    <StyledSection>
      <ModalComponent show={isVideoModal} size="lg" onHide={handleShowVideoModal}>
        <VideoPlayerComponent videoSource={modalVideoSrc} controls className="w-100" />
      </ModalComponent>
      <Container>
        <Row className="justify-content-between py-4 px-5 px-md-0">
          <Col xs={12} md={6} lg={5}>
            <HeroContentWrapper className="d-flex flex-column text-center text-md-end">
              <h2>
                مثل یک دانشمند فکر کن و <br /> ماجراجویی علمی خودت را آغاز کن.
              </h2>
              <p className="mx-auto">
                <strong>آزتو</strong> بستری برای ارائه مطالب علمی و درسی به صورت
                تعاملی، هوشمند و سرگرم کننده است که یادگیری لذت بخش و عمیق را برای
                دانش‌آموزان به ارمغان می‌آورد.
              </p>
              <HeroButtonsWrapper className="d-flex w-100 justify-content-center justify-content-md-end gx-3">
                <StyledHeroButton
                  bgColor="var(--secondary-color)"
                  color="var(--tertiary-color)"
                  className="border-0"
                  $shadow
                  onClick={() =>
                    handleShowVideoModal(
                      "https://dl.azeto.ir/landing/azeto.anime3.mp4"
                    )
                  }
                >
                  آزتو را بشناس
                  <StyledVideoCircle variant="Bold" size="35" />
                </StyledHeroButton>
                <StyledHeroButton
                  bgColor="var(--tertiary-color)"
                  color="var(--secondary-color)"
                  onClick={() =>
                    handleShowVideoModal(
                      "https://dl.azeto.ir/landing/azeto.anime3.mp4"
                    )
                  }
                >
                  یادگیری بیشتر
                  <PlayIcon variant="Bold" color="var(--primary-color)" size="35" />
                </StyledHeroButton>
              </HeroButtonsWrapper>
            </HeroContentWrapper>
          </Col>
          <Col xs={12} md={6}>
            <HeroBoyWrapper>
              <img
                width="540"
                src={studentBoyImgSrc}
                alt="student-boy"
                className="img-fluid"
              />
            </HeroBoyWrapper>
          </Col>
        </Row>
      </Container>
    </StyledSection>
  );
};

export default HeroSectionComponent;
